import React from 'react';

export default function Card({ children, style, title, extra, padding = '20px' }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 12,
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      border: '1px solid #F0F0F0',
      overflow: 'hidden', ...style
    }}>
      {title && (
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #F3F4F6',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between'
        }}>
          <span style={{ fontWeight: 700, fontSize: 15, color: '#1A1A2E' }}>{title}</span>
          {extra && <div>{extra}</div>}
        </div>
      )}
      <div style={{ padding }}>{children}</div>
    </div>
  );
}
